/**
 * Copyright (c) SAGE3 Development Team 2022. All Rights Reserved
 * University of Hawaii, University of Illinois Chicago, Virginia Tech
 *
 * Distributed under the terms of the SAGE3 License.  The full license is in
 * the file LICENSE, distributed as part of this software.
 */

export const colors = {
  green: {
    '50': '#ECF9F1',
    '100': '#C9EED8',
    '200': '#A6E3BF',
    '300': '#83D8A6',
    '400': '#60CC8D',
    '500': '#3EC174',
    '600': '#319B5D',
    '700': '#257446',
    '800': '#194D2E',
    '900': '#0C2717',
  },
  blue: {
    '50': '#EBF6FA',
    '100': '#C7E5F0',
    '200': '#A3D4E6',
    '300': '#7FC3DC',
    '400': '#5AB2D3',
    '500': '#36A2C9',
    '600': '#2B81A1',
    '700': '#216178',
    '800': '#164150',
    '900': '#0B2028',
  },
  gray: {
    '50': '#F2F2F2',
    '100': '#DBDBDB',
    '200': '#C4C4C4',
    '300': '#ADADAD',
    '400': '#969696',
    '500': '#808080',
    '600': '#666666',
    '700': '#4D4D4D',
    '800': '#333333',
    '900': '#1A1A1A',
  },
  orange: {
    '50': '#FEF2E7',
    '100': '#FCDBBB',
    '200': '#FAC48F',
    '300': '#F8AD63',
    '400': '#F69637',
    '500': '#F47F0B',
    '600': '#C36509',
    '700': '#924C07',
    '800': '#623304',
    '900': '#311902',
  },
  purple: {
    '50': '#EFEFF6',
    '100': '#D3D1E6',
    '200': '#B6B4D5',
    '300': '#9A96C5',
    '400': '#7D78B4',
    '500': '#605BA4',
    '600': '#4D4983',
    '700': '#3A3762',
    '800': '#272442',
    '900': '#131221',
  },
  yellow: {
    '50': '#FFF7E5',
    '100': '#FFE7B8',
    '200': '#FFD88A',
    '300': '#FFC95C',
    '400': '#FFB92E',
    '500': '#FFAA00',
    '600': '#CC8800',
    '700': '#996600',
    '800': '#664400',
    '900': '#332200',
  },
  red: {
    '50': '#FCECE8',
    '100': '#F8CABF',
    '200': '#F3A896',
    '300': '#EF866C',
    '400': '#EA6343',
    '500': '#E5411A',
    '600': '#B73415',
    '700': '#8A270F',
    '800': '#5C1A0A',
    '900': '#2E0D05',
  },
  cyan: {
    '50': '#EBFAFA',
    '100': '#C6F1F1',
    '200': '#A1E7E7',
    '300': '#7DDEDE',
    '400': '#58D5D5',
    '500': '#33CCCC',
    '600': '#29A3A3',
    '700': '#1F7A7A',
    '800': '#155151',
    '900': '#0A2929',
  },
  teal: {
    '50': '#ECF9F7',
    '100': '#C9EEE7',
    '200': '#A6E3D8',
    '300': '#83D8C9',
    '400': '#60CDBA',
    '500': '#3DC2AB',
    '600': '#319B89',
    '700': '#247566',
    '800': '#184E44',
    '900': '#0C2722',
  },
  pink: {
    '50': '#FBEAF2',
    '100': '#F3C4DB',
    '200': '#EB9EC4',
    '300': '#E378AD',
    '400': '#DB5296',
    '500': '#D32C80',
    '600': '#A92366',
    '700': '#7F1A4D',
    '800': '#551133',
    '900': '#2A091A',
  },
};
